import { firestoreAction } from 'vuexfire';

import con, { mutationTypes } from '../mutationTypes';
import { auth, db } from '../../firebase';
import usersApi from '../../firebase/users';

// Register mutations for auth state here before using them
mutationTypes.addModule('auth', true);
mutationTypes.add('auth', [
  'AUTH_INIT',
  'AUTH_DONE',
  'AUTH_ERROR',
  'AUTH_CLAIMS'
]);

const authStore = {
  namespaced: true,
  state: {
    error: null,
    loading: false,
    // `Vuexfire` needs state variables which have to bound to firebase refs
    // to be initialized as `Array` for collections and `Object` for documents.
    user: {},
    claims: {}
  },
  getters: {
    parsedError(state) {
      if (!state.error) return '';

      switch (state.error.code) {
        case 'auth/user-disabled':
          return 'You access has been disabled, contact admin!';
        case 'auth/user-not-found':
          return 'User corresponding to the given email does not exist';
        case 'auth/wrong-password':
          return 'Incorrect credentials, please check your password!';
        default:
          return 'Something went wrong, try again later!';
      }
    }
  },
  mutations: {
    [con.AUTH_INIT](state) {
      state.error = null;
      state.loading = true;
    },
    [con.AUTH_DONE](state) {
      state.loading = false;
    },
    [con.AUTH_ERROR](state, data) {
      (state.error = data.error), (state.loading = false);
    },
    [con.AUTH_CLAIMS](state, data) {
      state.claims = data;
    }
  },
  actions: {
    setUserRef: firestoreAction(async ({ bindFirestoreRef, commit }, uid) => {
      await bindFirestoreRef('user', db.collection('users').doc(uid));
      const idTokenResult = await auth.currentUser.getIdTokenResult();
      commit(con.AUTH_CLAIMS, idTokenResult.claims);
    }),
    doLogin: {
      root: true,
      async handler({ commit, dispatch }, { email, password }) {
        commit(con.AUTH_INIT);
        commit(con.LOADING_INIT, null, { root: true });

        try {
          const { user } = await auth.signInWithEmailAndPassword(
            email,
            password
          );
          await usersApi.update(user);
          await dispatch('setUserRef', user.uid);
          commit(con.AUTH_DONE);
          commit(con.LOADING_DONE, null, { root: true });
        } catch (error) {
          commit(con.AUTH_ERROR, { error });
          commit(con.LOADING_DONE, null, { root: true });

          throw error;
        }
      }
    },
    doProfileUpdate: async function({ commit, state }, data) {
      commit(con.AUTH_INIT);
      try {
        await usersApi.update(state.user, data);
        commit(con.AUTH_DONE);
      } catch (error) {
        commit(con.AUTH_DONE);
        throw error;
      }
    }
  }
};

export default authStore;
